module.exports = __webpack_public_path__ + "static/media/auditBanerImg.c7c17aa0.jpeg";